import { Typography } from "antd"

export const SURCHARGE_DISCLAIMER_OK_TEXT = 'I Agree, Turn On'

const SurchargeDisclaimer = () => <Typography.Paragraph strong>
  I understand that passing processing fees on to my customers is subject to card network rules (e.g., Visa,
  Mastercard) and federal, state, and local laws, and I am responsible for complying with them.
</Typography.Paragraph>

export default SurchargeDisclaimer
